var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "action"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77506 2.18572V6.17318H5.74579V2.18572H1.77506ZM1.44173 1.18572C1.07354 1.18572 0.775061 1.48419 0.775061 1.85238V6.50651C0.775061 6.8747 1.07354 7.17318 1.44173 7.17318H6.07912C6.44731 7.17318 6.74579 6.8747 6.74579 6.50651V1.85238C6.74579 1.48419 6.44731 1.18572 6.07912 1.18572H1.44173Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2187 6.33724C13.4153 6.33724 14.3853 5.36719 14.3853 4.17057C14.3853 2.97396 13.4153 2.00391 12.2187 2.00391C11.0221 2.00391 10.052 2.97396 10.052 4.17057C10.052 5.36719 11.0221 6.33724 12.2187 6.33724ZM12.2187 7.33724C13.9676 7.33724 15.3853 5.91947 15.3853 4.17057C15.3853 2.42167 13.9676 1.00391 12.2187 1.00391C10.4698 1.00391 9.05201 2.42167 9.05201 4.17057C9.05201 5.91947 10.4698 7.33724 12.2187 7.33724Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88581 9.49103C3.81886 9.41 3.69452 9.41043 3.62813 9.49192L1.5045 12.0982C1.45467 12.1594 1.45454 12.2471 1.5042 12.3084L3.62784 14.9298C3.69425 15.0118 3.81915 15.0122 3.88612 14.9307L6.03973 12.3093C6.09036 12.2477 6.09023 12.1588 6.03943 12.0973L3.88581 9.49103ZM2.85289 8.86025C3.31767 8.28983 4.188 8.28684 4.65669 8.85405L6.8103 11.4604C7.16592 11.8907 7.16681 12.5127 6.81241 12.9441L4.65881 15.5655C4.19001 16.1362 3.31568 16.1331 2.85081 15.5593L0.727178 12.9379C0.379548 12.5087 0.380418 11.8947 0.729263 11.4665L2.85289 8.86025Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9208 10.077C11.8571 9.96216 11.6918 9.96265 11.6288 10.0779L9.07559 14.7488C9.01488 14.8599 9.09526 14.9954 9.22184 14.9954H14.3643C14.4913 14.9954 14.5717 14.8591 14.5101 14.748L11.9208 10.077ZM10.7513 9.59826C11.1923 8.79154 12.3497 8.78811 12.7954 9.59221L15.3847 14.2631C15.8157 15.0407 15.2534 15.9954 14.3643 15.9954H9.22184C8.33581 15.9954 7.77315 15.0467 8.19813 14.2692L10.7513 9.59826Z",
    fill: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.40a594ce1489a48005a89061667e7347.svg";
export { ForwardRef as ReactComponent };